module.exports = __webpack_public_path__ + "media/images/application2/AppEvents__hero__socials__a--ig-b85f11c0407b7ccfaa5adce38512a3c5.svg";